import React from 'react';
import { OverlayEventDetail } from '@ionic/react/dist/types/components/react-component-lib/interfaces';
import ClusterToasts from '../ClusterToasts/ClusterToasts';
import { Trail } from '../../../../models/Trail';
import { TrailMapToastsContainer } from '../trailsOnMapStyles';
import SingleToast from '../SingleToast/SingleToast';

type MapToastsProps = {
	trails: Trail[];
	setActiveIndex: React.Dispatch<React.SetStateAction<any>>;
	onSelectTrail?: () => void;
};

const MapToasts: React.FC<MapToastsProps> = ({
	trails,
	setActiveIndex,
	onSelectTrail,
}) => {
	const onWillDismiss = (ev: CustomEvent<OverlayEventDetail>) => {
		if (ev.detail.role === 'confirm') {
		}
	};
	return (
		<>
			<TrailMapToastsContainer>
				{trails.length > 1 ? (
					<ClusterToasts
						trails={trails}
						setActiveIndex={setActiveIndex}
						onSelectTrail={onSelectTrail}
					/>
				) : (
					<SingleToast trail={trails[0]} onSelect={onSelectTrail} />
				)}
			</TrailMapToastsContainer>
		</>
	);
};

export default MapToasts;
